module.exports = __webpack_public_path__ + "img/yinlian.250a5da8.png";